import React from 'react';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import { isEmpty, pickBy, get, isEqual } from 'lodash';
import i18next from 'i18next';
import { translate } from 'react-i18next';
import moment from 'moment';

//import SettingsColumn from '../../../../../dashboard/components/SettingsColumn';//'../../../components/SettingsColumn';
import CancelAndSaveButtons from '../../../../../dashboard/components/CancelAndSaveButtons';
import FakeField from 'Parts/ui/components/fields/FakeField';
import EmailField from 'Parts/ui/components/fields/EmailField';
import TextField from 'Parts/ui/components/fields/TextField';

import EventAdminAttendeesTicketForm_en from './locales/EventAdminAttendeesTicketForm_en.json';
import EventAdminAttendeesTicketForm_fr from './locales/EventAdminAttendeesTicketForm_fr.json';

//import './EventAdminAttendeesTicketForm.less';

class EventAdminAttendeesTicketForm extends React.Component {
    constructor(props) {
        super(props);

        this.campaignId = props.match.params.campaignID;
        this.ticketId = props.match.params.ticketID;

        this.props.fetchPurchasedTicket(this.campaignId, this.ticketId, {}, true);
        this.props.fetchEvent(this.campaignId, true, {showSettings: true});

        i18next.addResourceBundle('en', 'EventAdminAttendeesTicketForm', EventAdminAttendeesTicketForm_en);
        i18next.addResourceBundle('fr', 'EventAdminAttendeesTicketForm', EventAdminAttendeesTicketForm_fr);
    }

    handleSubmit = event => {
        event.preventDefault();
        this.changeHasHappened = false;

        const { props } = this,
            { form, campaignId, ticket, updatePurchasedTicket } = props,
            { validateFields, isFieldTouched } = form;

        validateFields({ force: true }, (err, allValues) => {
            if (!err) {
                const updatedValues = pickBy(allValues, (value, key) => isFieldTouched(key));

                let values;
                if (Object.keys(updatedValues) && Object.keys(updatedValues).length > 0) {
                    values = {
                        ...updatedValues,
                    };

                    updatePurchasedTicket(campaignId, ticket.id, values);
                }
            }
        });
    };

    handleCancel = () => {
        this.props.form.resetFields();
    };

    render() {
        const {
            props,
            handleSubmit,
            handleCancel
        } = this,
        {
            t,
            ticket,
            form,
            campaign,
            locale,
            match,
            location,
            checkAuthorization,
            isUpdatePurchasedTicketInProgress,
            eventSettings
        } = props;

        return (
            <div className="">
                <Form className="EventAdminAttendeesTicketForm" onSubmit={handleSubmit}>
                    <div className="inputs">
                        <FakeField
                            data={ticket.ticketNumber}
                            label={t('Ticket number')}
                            className="EventAdminAttendeesTicketForm__Field"
                        />
                        <FakeField
                            data={ticket.referenceId}
                            label={t('Reference')}
                            className="EventAdminAttendeesTicketForm__Field"
                        />
                        <FakeField
                            data={ticket.addedOn && moment(ticket.addedOn).format('LLLL') || undefined}
                            label={t('Purshased on')}
                            className="EventAdminAttendeesTicketForm__Field"
                        />
                        <FakeField
                            data={ticket.attendedOn && moment(ticket.attendedOn).format('LLLL') || t("not attended yet")}
                            label={t('Attended on')}
                            className="EventAdminAttendeesTicketForm__Field"
                        />
                        {get(eventSettings, 'attendee.information.request') == 1 && get(eventSettings, 'attendee.information.email') == 1 &&
                        <EmailField
                            className="EventAdminAttendeesTicketForm__Field"
                            form={form}
                            fieldId={'email'}
                            label={t('Email address')}
                            placeholder={true}
                            initialValue={ticket.email}
                        />
                        }
                        <TextField
                            className="EventAdminAttendeesTicketForm__Field"
                            form={form}
                            fieldId={'firstName'}
                            label={t('First Name')}
                            placeholder={true}
                            initialValue={ticket.firstName}
                            required
                        />
                        <TextField
                            className="EventAdminAttendeesTicketForm__Field"
                            form={form}
                            fieldId={'lastName'}
                            label={t('Last Name')}
                            placeholder={true}
                            initialValue={ticket.lastName}
                            required
                        />
                        {get(eventSettings, 'attendee.information.request') == 1 && get(eventSettings, 'attendee.information.username') == 1 &&
                        <TextField
                            className="EventAdminAttendeesTicketForm__Field"
                            form={form}
                            fieldId={'username'}
                            label={t('User Name')}
                            placeholder={true}
                            initialValue={ticket.username}
                            required
                        />
                        }
                    </div>
                    <CancelAndSaveButtons onClickCancel={handleCancel} isSavingInProgress={isUpdatePurchasedTicketInProgress} />
                </Form>
                {/* <SettingsColumn>
                    <LanguageBoxForm
                        handleContentLanguageChange={handleContentLanguageChange}
                        changeHasHappened={this.changeHasHappened}
                        defaultLanguage={
                        getDefaultLanguageKey(get(this.props, 'participant.description')) ||
                        getDefaultLanguageKey(get(this.props, 'languages')) ||
                        this.props.locale
                        }
                        disabled={disableFields}
                    />
                </SettingsColumn> */}
            </div>
        );
    }
}

EventAdminAttendeesTicketForm.defaultProps = {};

EventAdminAttendeesTicketForm.propTypes = {
    form: PropTypes.object.isRequired
};

export default translate('EventAdminAttendeesTicketForm')(EventAdminAttendeesTicketForm);
